//import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Component,OnInit,Inject,ElementRef,ViewChild,Input } from '@angular/core';
import { HttpClient,HttpErrorResponse } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

import { ValidityResultModel } from '../../models/validity-result-model';
import { RoleResultModel } from '../../models/role-result-model';

import { HeaderSharingService } from '../../core/services/header-sharing.service';
import { ChangeLangModel } from '../../models/change-lang-model';
import { LoginService } from '../../core/middleware-call/login.service';
import { SharedService } from '../../core/middleware-call/shared.service';
import { ThemeService } from '../../core/theme/theme.service';
import { PlatformLocation } from '@angular/common';
import { NgbModalConfig,NgbModal,NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { ErrorHandlerService } from '../../error-handler.service';
import { SidebarSharingService } from '../../core/services/sidebar-sharing.service';
import { RHService } from '../../core/middleware-call/rh.service';

import { ResizedEvent } from 'angular-resize-event'; // v2
import { AffService } from '../../core/middleware-call/aff.service';

import { Title } from '@angular/platform-browser';
import { Router,ActivatedRoute,NavigationStart,NavigationEnd,NavigationError } from '@angular/router';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    public pushRightClass: string;
    username: string;
    isExpanded: boolean=false;
    isExpandedjkaVersion: boolean=false;
    //appTitle: string; // usage???
    role: string;
    validity: ValidityResultModel;
    lang: ChangeLangModel;
    cookieValue: string;
    // Define a variable to use for showing/hiding the Login button ( via header sharing service)
    isUserLoggedIn: boolean;
    seed: number; // for toggeling display of components
    currentAffiliateScheme: number;
    hasChosenPlan: boolean=false;
    schName: string;
    cieName: string;
    currentAffiliateName: string="";
    currentSchemeName: string="";
    currentCompanyName: string="";
    isRhAndNotAdmin: boolean=false;

    isThemeDark: boolean;
    currentTheme: string;
    companyName: string;
    hasOnlyOneCompany: boolean = false;

    allowHeaderBarChecks: boolean=false;
    currentHeaderBarHeight: number;
    numberOfSchemes: number;

    @Input() hideSelectPlan: number;

    //width: number; //v2
    //height: number; // v2
    currentThemeInfoForMoonSunIconToggle: boolean;

    constructor(
        private _elRef: ElementRef, //v3 detect rize height chnage
        public errorHandler: ErrorHandlerService,
        private http: HttpClient,
        public translate: TranslateService,
        private headerSharingService: HeaderSharingService,
        private affService: AffService,
        private sidebarSharingService: SidebarSharingService,
        public loginService: LoginService,
        public sharedService: SharedService,
        private cookieService: CookieService,
        private themeService: ThemeService,
        private router: Router,
        private location: PlatformLocation,
        private modalService: NgbModal,
        private rhService: RHService,
        private activatedRoute: ActivatedRoute,
        private titleService: Title,
        @Inject('BASE_URL') baseUrl: string) {
        // this will automatically update 
        // "isUserLoggedIn" whenever a change to the subject is made.
        location.onPopState(() => this.closeModal());

        // Function to subscribe to header and sidebar services
        this.getHeaderSharingServiceLoggedIn();
        this.getHeaderSharingServiceRole().then(result => {
            if(this.role=='RH') {
                this.getHeaderSharingServiceNavState();
                this.getRhRole();
            }
        });
        this.getHeaderSharingServiceSeed();
        this.getSidebarSharingServiceAffId();

        this.currentThemeInfoForMoonSunIconToggle=this.themeService.isDarkTheme(); // ini Toggle icon

        this.isThemeDark=this.themeService.isDarkTheme(); // ini Toggle icon

        this.getTitleHandler();
    }

    ngOnInit() {

        console.log("calling getCompanyName");

        this.getNumberOfSchemes();

        this.isExpanded=false;
        //sub to theme
        this.getThemeIsDark();
        this.getCurrentTheme(); // actually subscribeToCurrentThemeName

        this.loadPreferredTheme();

        this.pushRightClass='push-right'; // @max?

        // set up the language cookie
        this.cookieValue=this.cookieService.get('Language');
        //this.initRole();
        if(this.role!=null)
            this.getValidity();
        // NB: this.initGreetingMessage() placed after initRole call instead of here to assure sequential execution
        this.username=localStorage.getItem("username"); // get username set by login component
        this.schName=sessionStorage.getItem("STORAGE_SCHNAME"); // get headerBarPlanTitle set plan selection
        this.cieName=sessionStorage.getItem("STORAGE_CIENAME");
        console.log("schName > "+this.schName);
        this.getTitleHandler();
    }

    ngAfterViewInit() {
        console.log("ngAfterViewInit header component");
        this.allowHeaderBarChecks=true; // prevent ExpressionChangedAfterItHasBeenCheckedError onload if headerbar is different from 1 (1 line)
    }
    //onResized(event: ResizedEvent) { // v2
    //  //this.width = event.newWidth;
    //  //this.height = event.newHeight;
    //  //console.log("VVV 2 resize on navbar detected = "+this.width+":::"+this.height );
    //}

    @ViewChild('navBarV3Detector') nBarV3: ElementRef; //v3
    @ViewChild('dropExpandDetector2') dropExpandDetector2: ElementRef; // debug header adapt on drop downs
    @ViewChild('dropExpandDetector') dropExpandDetector: ElementRef; //
    //ngAfterViewChecked() {
    //    // use this.theDiv to examine the div property of interest
    //    console.log("VVV 3 ngAfterViewChecked" );
    //  }
    ngDoCheck() {

        if(this.role!=null) { // prevent errors on session expired
            if(this.allowHeaderBarChecks&&this.router.url!="/public"&&this.router.url!="/login"
                &&this.dropExpandDetector2.nativeElement.ariaExpanded=='false'
                &&this.dropExpandDetector.nativeElement.ariaExpanded=='false') {
                if(this.nBarV3.nativeElement.scrollHeight>100) {
                    if(this.currentHeaderBarHeight!=3||this.currentHeaderBarHeight==null) {
                        this.currentHeaderBarHeight=3;
                        this.headerSharingService.headerBarHeight.next(3);
                    }
                } else if(this.nBarV3.nativeElement.scrollHeight>75) {
                    if(this.currentHeaderBarHeight!=2||this.currentHeaderBarHeight==null) {
                        this.currentHeaderBarHeight=2;
                        this.headerSharingService.headerBarHeight.next(2);
                    }
                } else {
                    if(this.currentHeaderBarHeight!=1||this.currentHeaderBarHeight==null) {
                        this.currentHeaderBarHeight=1;
                        this.headerSharingService.headerBarHeight.next(1);
                    }
                }
            }
        }
    }



    onLoggedout() {
        localStorage.removeItem('isLoggedin');
    }

    /* ini the preferred theme */
    loadPreferredTheme() {

        // default light
        this.themeService.setLightTheme();

        // demo lalux
        //this.themeService.setLaLuxTheme();

        // if cookie exists

        // else if session exists
        if (sessionStorage.getItem("PREFERRED_THEME") != "" && sessionStorage.getItem("PREFERRED_THEME") != null) {
            if (sessionStorage.getItem("PREFERRED_THEME") == "light") this.themeService.setLightTheme();
            if (sessionStorage.getItem("PREFERRED_THEME") == "dark") this.themeService.setDarkTheme();
        }

    }


    toggleHeader() {
        const dom: any=document.querySelector('body');
        dom.classList.toggle(this.pushRightClass);
    }

    expandListener() {
        this.isExpandedjkaVersion=true;
    }

    /**
     * Subscribe to isUserLoggedIn from HeaderSharingService
     */
    getHeaderSharingServiceLoggedIn() {
        console.log("getHeaderSharingServiceLoggedIn");
        this.headerSharingService.isUserLoggedIn.subscribe(value => {
            this.isUserLoggedIn=value;
            console.log("We check if user is logged in : "+value);

            // bugfix/workaround where fatca reloads blank page on session expired
            //if (value == false && this.router.url.indexOf('fatca')>-1)
            //    this.router.navigate(['/public/sessionExpired']); 
        })
    }

    /**
     * Subscribe to affId, hasChosenPlan and schName from SidebarSharingService
     */
    getSidebarSharingServiceAffId() {
        console.log("getSidebarSharingServiceAffId");
        this.sidebarSharingService.hasChosenPlan.subscribe(value => {
            this.hasChosenPlan=value;
            console.log("We check if a plan has already been chosen");
        });

        // ???
        this.sidebarSharingService.schName.subscribe(value => {
            this.schName=value;
            console.log("[[[[ We check the current scheme name : "+value);
        });
        this.sidebarSharingService.cieName.subscribe(value => {
            this.cieName=value;
            console.log("[[[[[[ We check the current cieName; calling from inside header component, reading from SidebarSharingService : "+value);
        });
    }


    getHeaderSharingServiceNavState() {
        console.log("getHeaderSharingServiceNavState");
        this.headerSharingService.currentCompanyName.subscribe(value => {
            this.currentCompanyName=value;
            console.log("We check if a company has already been chosen");
        });
        this.headerSharingService.currentSchemeName.subscribe(value => {
            this.currentSchemeName=value;
            console.log("We check if a plan has already been chosen");
        });
        this.headerSharingService.currentAffiliateName.subscribe(value => {
            this.currentAffiliateName=value;
            console.log("We check if an affiliate has already been chosen");
        });
        this.headerSharingService.hasOnlyOneCompany.subscribe(value => {
            this.hasOnlyOneCompany = value;
            console.log("We check if the HR manages only one company");
        });
    }

    logOff() {
        console.log("Log Off called in header.component.ts")
        localStorage.clear();
        sessionStorage.clear();
        this.headerSharingService.logOff().then(res => {
            this.router.navigate(['/public']);
        });
    }

    /**
     * Subscribe to role from HeaderSharingService
     */
    getHeaderSharingServiceRole() {
        console.log("getHeaderSharingServiceRole");
        return new Promise((resolve,reject) => {
            this.headerSharingService.role.subscribe(value => {
                this.role=value;
                console.log("We check what role currently is in navbar : "+this.role);
                resolve('OK');
            })
        });

    }

    // such subscriptions execute on every change of the headerservices value
    /* seed determins display location of components */
    getHeaderSharingServiceSeed() {
        console.log("getHeaderSharingServiceSeed");
        this.headerSharingService.seed.subscribe(value => {
            this.seed=value;
            console.log("We check seed value from headerservice : "+this.seed);
        })
    }

    /***
     * Checks if the conditions needed to log into home page are met
     * */
    getValidity() {
        this.validity=new ValidityResultModel();
        this.loginService.initValidity().subscribe(
            result => {
                console.log("Results from getValidity");
                this.validity=result;
                console.log(this.validity.role);
                console.log(this.validity.emailNeedsToBeEntered);
                console.log(this.validity);
            },
            error => {
                console.error("Error on callback validity");
                this.errorHandler.handleError(error);
            });
    }

    getNumberOfSchemes() {
        this.affService.getNumberOfSchemes().subscribe(
            result => {
                this.numberOfSchemes=result;
                console.log(result+"schemes available");
            },
            error => {
                console.error("Error on callback validity");
                this.errorHandler.handleError(error);
            });
    }

    /***
    *  Debug function that corrupts session token
    * */
    corruptMySession() {
        this.http.get<string>('api/Login/CorruptMySession').subscribe(
            result => {
                console.log("corruptMySession "+result);
            },
            error => {
                console.error("Error on callback corruptMySession");
            });
    }
    corruptMySessionDelayed() {
        //wait 5 seconds;
        setTimeout(() => this.corruptMySession(),5000);
    }


    // makes the call to set the new lanCode in db + sets the translate service to use the given lanCode if the call to midleware succeeded
    changeLang(language) {

        
        if(this.isUserLoggedIn==true) {
                this.lang=new ChangeLangModel();
                this.lang.lang=language;
                console.log(language);

                // do the change in angular
                this.translate.use(language); 

                // notify backend of the change
                this.sharedService.changeLang(this.lang).subscribe(result => {
                    console.log(result);
                    this.getTitleHandler(); 
                },
                error => {
                    console.error("Error on changeLang");
                    this.errorHandler.handleError(error);
                });
        }
        else {
            // if the user isn't logged in, the button will not update his profile language but his cookies
            this.translate.use(language);
            this.cookieService.set('Language',language);
        }
        this.isExpanded=false; // collapse mobile headerbar
    }

    /* Allows to switch colors - could be used via preferences set on plan or user data - or even as live option for user ... nightmode + keeping plan color settings etc  */
    toggleTheme() {
        console.log("Toggle detected + "+this.themeService.isDarkTheme());

        let deactivatedFeature=false;

        if(!deactivatedFeature) {

            if(this.currentTheme=="light") {
                this.themeService.setDarkTheme();
                sessionStorage.setItem("PREFERRED_THEME","dark");
                this.currentThemeInfoForMoonSunIconToggle=false;
            } else if(this.currentTheme=="dark") {
                this.themeService.setLightTheme();
                sessionStorage.setItem("PREFERRED_THEME","light");
                this.currentThemeInfoForMoonSunIconToggle=true;
            }

            //if (this.currentTheme == "light") {
            //    this.themeService.setDarkTheme();
            //    sessionStorage.setItem("PREFERRED_THEME", "dark");
            //    this.currentThemeInfoForMoonSunIconToggle = false;
            //} else if (this.currentTheme == "dark") {
            //    this.themeService.setLaLuxTheme();
            //    sessionStorage.setItem("PREFERRED_THEME", "laLux");
            //    this.currentThemeInfoForMoonSunIconToggle = true;
            //} else if (this.currentTheme == "laLux") {
            //    this.themeService.setAxaTheme();
            //    sessionStorage.setItem("PREFERRED_THEME", "axa");
            //    this.currentThemeInfoForMoonSunIconToggle = true;
            //} else if (this.currentTheme == "axa") {
            //    this.themeService.setLightTheme();
            //    sessionStorage.setItem("PREFERRED_THEME", "light");
            //    this.currentThemeInfoForMoonSunIconToggle = true;
            //}

        }

        this.isExpanded=false; // collapse mobile headerbar
    }

    // used to rearrange the display of components
    /* 5 = grid ; 6 = grid mobile */
    toggleSeed() {
        if(this.seed<8) {
            this.headerSharingService.seed.next(this.seed+1);
        }
        else this.headerSharingService.seed.next(1);
    }


    closeModal() {
        this.modalService.dismissAll();
    }


    getRhRole() {
        this.rhService.isRhAndNotAdmin().subscribe(result => {
            this.isRhAndNotAdmin=result;
        });
    }

    getThemeIsDark() {
        this.themeService.themeIsDark.subscribe(
            value => {
                this.isThemeDark=value;
                console.log("themeTrigger"+value);
            });
    }

    getCurrentTheme() {
        this.themeService.currentTheme.subscribe(
            value => {
                this.currentTheme=value;
                console.log("current theme "+value);
            });
    }


    collapseMenu() {
        this.isExpanded=false;
    }



    getCompanyName() {
        return new Promise((resolve,reject) => {
            console.log("getCompanyName triggered");
            this.sharedService.getCompanyName().subscribe(result => {
                this.companyName=result.companyName;
                resolve("OK")
            },error => {
                console.error("error on callback isPortfolioRepartitionEnabled");
                console.error(error);
                this.companyName="";
                resolve("NOK");
            })
        });
    }



    /** Set companyName from route var or default to companName from appSettings.json, then put it into title */
    getTitleHandler(){
console.log("#### TITLE HANDLER TRIGGERED ####");
            var title=this.activatedRoute.snapshot.firstChild.data.title;
            if(title!==undefined) {
                this.titleService.setTitle(this.translate.instant(title));
            } else {
                // fallback, getting company name from service in mid providing name from appsettings.json file
                this.getCompanyName().then(result => {
                    this.titleService.setTitle(this.companyName);
                })
            } 
    }

}
